const Slider = {
  init () {

    /*
    * Slider(s) - Slick Carousel
    * https://kenwheeler.github.io/slick/
    */

    // Vanilla Slider
    if ( jQuery('.c-slider--simple').length ) {
      jQuery('.c-slider--simple').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        infinite: true,
        dots: false,
        arrows: false,
        fade: true,
        cssEase: 'linear'
      });
    }

    // Hero Slider
    if ( jQuery('.c-slider--hero').length ) {
      jQuery('.c-slider--hero').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        dots: true,
        arrows: false,
        fade: true,
        cssEase: 'linear'
      });
    }

    // CTA Banner Slider
    if ( jQuery('.c-slider--cta').length ) {
      jQuery('.c-slider--cta').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        dots: true,
        arrows: false,
        fade: true,
        cssEase: 'linear'
      });
    }

    // Logos Slider
    if ( jQuery('.c-slider--logos').length ) {
      jQuery('.c-slider--logos').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        infinite: true,
        dots: false,
        arrows: true,
        fade: false,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 641,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 481,
            settings: {
              slidesToShow: 1,
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });
    }

    // Products Slider
    if ( jQuery('.c-slider--products').length ) {
      jQuery('.c-slider--products').slick({
        slidesToShow: 4,
        slidesToScroll: 2,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        dots: false,
        arrows: true,
        fade: false,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          },
          // {
          //   breakpoint: 640,
          //   settings: {
          //     slidesToShow: 1,
          //   }
          // },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });
    }

    // News Slider
    if ( jQuery('.c-slider--news').length ) {
      jQuery('.c-slider--news').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        dots: false,
        arrows: true,
        fade: false,
        cssEase: 'linear',
        responsive: [
          // {
          //   breakpoint: 768,
          //   settings: {
          //     slidesToShow: 2,
          //   }
          // },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
            }
          },
          // {
          //   breakpoint: 480,
          //   settings: {
          //     slidesToShow: 1,
          //     slidesToScroll: 1
          //   }
          // }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });
    }

  }
};

export default Slider;
